<template>
  <v-dialog :value="value" @input="$emit('input')" transition="fade-transition" max-width="700px">
    <v-card v-if="activePairingData" style="min-width:400px">
      <v-card-title class="subtitle-1">For your internal communication only, neither Kobe nor the creators would have access to these notes</v-card-title>
      <v-card-text>
        <!-- <a
          class="title"
          :href="'https://www.instagram.com/' + activePairingData.instagramHandle"
          target="_blank"
        >@{{activePairingData.instagramHandle}}</a> -->
        <a :href="'https://www.tiktok.com/@' + activePairingData.instagramHandle" target="_blank" v-if="activePairingData.platform && activePairingData.platform === 'tiktok'"><img src="/static/img/tiktok-32.png" width="20px" /> @{{activePairingData.instagramHandle}}</a>
        <a :href="'https://www.instagram.com/' + activePairingData.instagramHandle" target="_blank" v-else><v-icon color="#000000" small>mdi-instagram</v-icon> @{{ activePairingData.instagramHandle }}</a>
        <v-row class="mt-2">
          <v-col cols="12" v-if="isClientRole">
            <v-textarea
              outlined
              name="notes"
              label=""
              hide-details
              v-model="activePairingData.notes"
              value
              @input="$v.activePairingData.notes.$touch()"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row v-if="activePairingData.clientNotes.length > 0">
          <v-col class="mt-0 pt-0" cols="12" md="12" sm="12" lg="12">
            <v-card flat max-height="300px" class="overflow-hidden overflow-y-auto">
              <v-card-text class="mt-0 pt-0" v-if="activePairingData.clientNotes.length > 0">
                <element v-for="(msg, index) in activePairingData.clientNotes" :key="index">
                  <v-row>
                    <v-col>
                      <p class="body-2 font-weight-bold">{{msg.author ? msg.author.name : '-'}}</p>
                    </v-col>
                    <v-col class="text-right">
                      <v-btn 
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Delete Note"
                        @click="deleteNote(fileIndex)"
                        color="error"
                        small
                        v-if="showAction(msg)">
                          <v-icon color="white" small>delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <p class="body-1 font-weight-medium">{{msg.notes}}</p>
                  <p class="caption text-xs-right font-italic">{{formatTime(msg.timestamp)}}</p>
                  <v-divider></v-divider>
                </element>
              </v-card-text>
              <v-card-text v-else>
                <p class="body-1 font-weight-bold">
                  No Internal Notes
                </p>
              </v-card-text>
            </v-card>
            <!-- <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Date Time</th>
                    <th class="text-left">Client</th>
                    <th class="text-left">Notes</th>
                    <th class="text-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, fileIndex) in activePairingData.clientNotes" :key="item.timestamp">
                    <td>{{ formatTime(item.timestamp) }}</td>
                    <td>{{ item.author ? item.author.name : '-' }}</td>
                    <td>{{ item.notes }}</td>
                    <td>
                      <v-btn 
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Delete Note"
                      @click="deleteNote(fileIndex)"
                      color="error"
                      small
                      v-if="showAction(item)">
                        <v-icon color="white" small>delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table> -->
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input')">Close</v-btn>
        <v-btn color="green darken-1" text @click="saveNote()" v-if="isClientRole">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-dialog>
</template>
<script>
// import utils from '../../../../utils'
import pairingAPIs from '../../Pairing/pairingAPIs';
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import reverse from 'lodash/reverse';
import Loading from 'vue-loading-overlay';
import { mapState } from 'vuex';
import config from '@/config';
// import config from '../config';
export default {
  components: { Loading },
  data() {
    return {
      activePairingData: null,
      isLoading: false
    };
  },
  props: {
    value: Boolean,
    data: Object
  },
  watch: {
    value(value) {
      if (value) {
        this.activePairingData = Object.assign({}, this.data);
        this.clearForm()
      }
    }
  },
  computed: {
    ...mapState(['user']),
    currentUserID: function () {
      return this.$store.state.user.id;
    },
    isClientRole: function () {
      // for client role only
      return Number(this.$store.state.user.role) === config.userRoles.CLIENT;
    }
  },
  validations: {
    activePairingData: {
      notes: {
        required
      }
    }
  },
  methods: {
    saveNote() {
      if (this.activePairingData !== null) {
        let formData = new FormData();
        formData.append('pairingID', this.activePairingData.pairingID);
        formData.append('notes', this.activePairingData.notes);
        this.isLoading = true
        pairingAPIs
          .saveClientNote(formData)
          .then((response) => {
            this.isLoading = false
            this.activePairingData.clientNotes = response.clientNotes
            this.beautifyData()
            this.$swal({
              position: 'top-center',
              title: 'Successfully Saved Notes!',
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            this.$emit('savedNotes')
            this.$emit('input');
          })
          .catch(error => {
            this.isLoading = false
            this.$swal({
              position: 'top-center',
              title: 'Error while saving note',
              type: 'error',
              timer: 1500
            });
            console.log(error);
          });
      }
    },
    deleteNote(fileIndex) {
      this.$swal({
        title: 'Delete Confirm!',
        text: 'Are you sure you want to delete note?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          let updateNote = Object.assign([], this.activePairingData.clientNotes)
          updateNote.splice(fileIndex, 1)
          let formData = new FormData();
          formData.append('pairingID', this.activePairingData.pairingID);
          formData.append('clientNotes', JSON.stringify(updateNote));
          this.isLoading = true;
          pairingAPIs.saveClientNote(formData)
            .then(response => {
              this.activePairingData.clientNotes = updateNote
              this.isLoading = false;
              // Dismiss modal by triggering the click event on Close button
              this.$swal({
                text: 'Note Deleted',
                type: 'success'
              });
              this.$emit('savedNotes')
            })
            .catch(error => {
              // Request failed.
              console.log('error', error)
              this.isLoading = false;
            })
        }
      })
    },
    beautifyData() {
      if (this.activePairingData.clientNotes !== undefined) {
        this.activePairingData.clientNotes = reverse(this.activePairingData.clientNotes)
      }
    },
    showAction(item) {
      if (item.author !== undefined) {
        if (item.author.id === this.currentUserID && this.isClientRole) {
          return true
        }
      }
      return false
    },
    clearForm() {
      this.activePairingData.notes = ''
    },
    formatTime(value) {
      return moment(value).fromNow();
    }
  }
};
</script>



// WEBPACK FOOTER //
// ClientNotesModal.vue?5a4cd744